// validators/match-passwords.validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function matchPasswords(passwordKey: string, confirmKey: string): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const password = group.get(passwordKey)?.value;
    const confirm = group.get(confirmKey)?.value;

    if (password !== confirm) {
      group.get(confirmKey)?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      // Limpia el error si ya coinciden
      if (group.get(confirmKey)?.hasError('passwordMismatch')) {
        group.get(confirmKey)?.setErrors(null);
      }
      return null;
    }
  };
}
